<template>
  <div class="site-wrap">
    <el-card :body-style="{ padding: '0 0 16px' }">
      <el-tabs v-model="activeTab">
        <template v-for="(item, index) in tabs">
          <el-tab-pane
            :label="item.label"
            :name="item.name"
            :key="index"
            v-if="authList.includes(item.auth)"
          ></el-tab-pane>
        </template>
      </el-tabs>
    </el-card>
    <div class="search-wrap">
      <component :is="componentName"></component>
    </div>
  </div>
</template>

<script>
import paySetting from './pay-setting.vue'
import warnSetting from './warn-setting.vue'
export default {
  components: { paySetting, warnSetting },
  data() {
    return {
      activeTab: null,
      tabs: [
        {
          label: this.$t('paypal::monitor::PayPal账户'),
          name: '1',
          auth: 'shop-management::paypal::setting::paySetting',
        },
        {
          label: this.$t('paypal::monitor::预警设置'),
          name: '2',
          auth: 'shop-management::paypal::setting::warnSetting',
        },
      ],
    }
  },
  created() {
    if (this.authPromise('paypal::setting::paySetting')) {
      this.activeTab = '1'
    } else if (this.authPromise('paypal::setting::warnSetting')) {
      this.activeTab = '2'
    }
  },
  activated() {
    if (this.$route.query.type) {
      this.activeTab = this.$route.query.type
    }
  },
  computed: {
    componentName() {
      switch (this.activeTab) {
        case '1':
          return 'paySetting'
        case '2':
          return 'warnSetting'
        default:
          return ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__nav {
  padding-left: 16px;
}
/deep/.el-tabs__active-bar {
  left: 16px;
}
.site-wrap {
  position: relative;
  .search-wrap {
    margin-top: -30px;
  }
}
</style>
